module.exports = {
  QueryBalance: 'Query Balance',
  QueryDetail: 'Query Detail',
  BalanceDetail: 'Balance Detail',
  FinanceBalance: 'Finance Balance',
  SendBalance: 'Send Balance',
  QuerySendBalanceState: 'Query Send Balance State',
  InitializeBalance: 'Initialize Balance',
  QuickSearchBalance: 'Quick Search:Customer Code',
  CustomerName: 'Customer Name',
  CustomerCode: 'Customer Code',
  SalesName: 'Sales Name',
  ParentBranchName: 'Parent BranchName',
  ParentBranchCode: 'Parent BranchCode',
  BranchName: 'Department Name',
  BranchCode: 'Department Code',
  BranchId: 'Branch Id',
  Balance: 'Balance',
  DateCreated: 'Created Date',
  State: 'Send Balance State',
  SubmittingAmount: 'Submitting Amount',
  ShowChildData: 'Show Child Data',
  ChangeAmount: 'Change Amount',
  ChangeType: 'Change Type',
  LatestBalance: 'Latest Balance',
  ChangeDate: 'Change Date',
  Currency: ' 通貨',
  JobNo: 'Job No',
  FinanceUpdateDate: 'Finance Update Date',
  SyncDate: 'Sync Date',
  CheckBalanceTitle: 'Insufficient Balance',
  CheckBalanceDetail: '{0}，[{1}]{2}：Current Balance RMB {3}。Submitted RMB {4}。Submitting RMB {5}',
  CheckBalanceDetail2: '[{0}]{1}：Current Balance RMB {2}。Submitted RMB {3}。Submitting RMB {4}',
  CustSettlement: 'Cust Settlement',
  InstCode: 'Inst Code',
  InstName: 'Inst Name',
  SrcSystem: 'Src System',
  AdvBalance: 'Adv Balance',
  OrderType: 'Order Type',
  BlacklistRemark: 'Blacklist Remark',
  AddedToBlacklist: '{0} has added to the blacklist',
  BalanceInitialized: 'After initializing the balance, "prepayment" customers cannot switch back to "under payment"',
  CustomerCodeDuplicate: 'Customer code duplication',
  NoMatchStateBySelected: 'No record with status [{0}] selected',
  SendCustomerInfo: 'Send customer info',
  SendCustomerRemind: '*Reminder: Please confirm that the department code and name are consistent with the code and name of the fund claiming institution in the business finance system.'
}
